module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/experiences/wedding/ecowedding_02-photolayout-03.png";